<template>
    <transition name="fade">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-12 col-sm-12">

                <transition name="fade">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title bold">Kindly follow our guide questions to apply a loan</h3>
                        </div>
                        <div class="card-body">
                            <p class="card-text text-justify">Has your business been in operation for at least 1 year?</p>
                            <div class="row">
                                <div class="col-6 text-center">
                                    <div class="icheck-primary d-inline">
                                        <input type="radio" id="y-q1" value="Y" v-model="formLoan.bus_year">
                                        <label for="y-q1" :class="{ 'errorRadio': $parent.submitting && $v.formLoan.bus_year.$error }">Yes</label>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="icheck-primary d-inline">
                                        <input type="radio" id="n-q1" value="N" v-model="formLoan.bus_year">
                                        <label for="n-q1" :class="{ 'errorRadio': $parent.submitting && $v.formLoan.bus_year.$error }">No</label>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="card-footer">
                            <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                            <button class="btn btn-primary float-right" @click="next">Next<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>

                    </div>
                </transition>
            </div>
        </div>
    </transition>
</template>
<script>
    import {
        required,
        minLength
    } from 'vuelidate/lib/validators';

    export default {
        props: ['formLoan'],
        data() {
            return {}
        },

        validations: {
            formLoan: {
                bus_year: {
                    required
                },
            },
        },
        created() {

        },
        methods: {
            next() {
                this.$parent.submitting = false;
                this.$parent.submitting = true;
                this.$v.formLoan.$touch();
                if (this.$v.formLoan.$invalid) {
                    
                } else {
                    if (this.formLoan.bus_year == 'Y') {
                        this.$emit('next');
                    } else {
                        this.$parent.notQualified();
                    }
                }
            },
        },
        computed: {},
        mounted() {}
    }
</script>



<style scoped>
    label {
        font-weight: 400 !important;
    }
</style>